import { useState } from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import fetchCountByPeriod from 'modules/payroll_integrations_datev_api/lib/getSupplements'
import KomboSupplementsToSync from 'modules/payroll_integrations_kombo/components/SupplementsSyncPreview/SupplementsToSync'

interface Props {
  policyPeriodId: number
  integrationLabel: string
}

const SupplementsToSync = ({ policyPeriodId, integrationLabel }: Props) => {
  const [count, setCount] = useState<number>(0)

  useAsyncData(async () => {
    setCount(await fetchCountByPeriod(policyPeriodId))
  }, [policyPeriodId])

  return (
    <KomboSupplementsToSync
      count={count}
      integrationLabel={integrationLabel}
    ></KomboSupplementsToSync>
  )
}

export default SupplementsToSync
